<template>
  <b-modal
    ref="reseller_cameras"
    id="reseller-cameras"
    @show="onShow"
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    scrollable
    size="lg"
    centered
  >
    <div style="height: 525px; max-width: 100%; overflow-y: auto">
      <b-card no-body class="m-2">
        <b-card-body>
          <b-row>
            <b-col cols="12" md="12" class="mb-md-0 mb-2 text-capitalize">
              <label>{{ $tc("reseller.title", 2) }}</label>
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="filterReseller"
                :options="resellerOptions"
                class="w-100"
                :reduce="(val) => val.value"
                multiple
              />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-card class="m-2" no-body>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="text-capitalize">{{ $t("table.show") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label class="text-capitalize">{{ $t("table.entries") }} </label>
            </b-col>

            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  class="d-inline-block mr-1"
                  :placeholder="$t('table.search') + '...'"
                  @input="onTypeSearch"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refListTable"
          class="position-relative"
          :items="itemsData"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="$t('no_record_found')"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template #head(name)="data">
            <span> {{ $t(data.label) }}</span>
          </template>

          <template #head(ethMacAddress)="data">
            <span> {{ $t(data.label) }}</span>
          </template>

          <template #head(cameraId)="">
            <b-form-checkbox
              v-if="totalList"
              id="select-all"
              value="1"
              unchecked-value="0"
              v-model="selectAll"
              :disabled="isBusy"
            >
            </b-form-checkbox>
          </template>

          <template #cell(cameraId)="data">
            <b-form-checkbox
              :disabled="data.item.exist"
              :id="`camera-${data.item.cameraId}`"
              :value="data.item.cameraId"
              unchecked-value="0"
              v-model="camerasModel"
              @change="checkItem(data.item)"
            >
            </b-form-checkbox>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted text-capitalize">{{
                $t("table.showing", {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}</span>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalList"
                :per-page="perPage"
                prev-class="prev-item"
                next-class="next-item"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <template #modal-footer>
      <b-button
        variant="info"
        size="sm"
        class="text-capitalize"
        :disabled="buttonUpdate"
        @click="updateResellerCameras"
      >
        {{ $t("actions.update") }}
      </b-button>
      <b-button
        size="sm"
        variant="secondary"
        class="text-capitalize"
        :disabled="buttonUpdate"
        @click="$bvModal.hide('reseller-cameras')"
      >
        {{ $t("actions.cancel") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BCard, BRow, BCol, BFormInput, BTable, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, watch, computed } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import Pagination from "@/components/Pagination.vue";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import { debounce } from "lodash";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    vSelect,
    Pagination,
    ToastificationLoadingContent,
  },
  props: {
    resellerOptions: {
      type: Array,
      default: null,
    },
    resellerFilter: {
      type: Array,
      default: null,
    },
  },

  setup(props, { emit, parent }) {
    const isBusy = ref(false);
    const refListTable = ref(null);
    const perPage = ref(10);
    const totalList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const buttonUpdate = ref(false);
    const filterReseller = ref(null);
    const resellerCameras = ref([]);
    const resellerCamerasTemp = ref([]);
    const cameras = ref([]);
    const camerasModel = ref([]);
    const selectAll = ref(null);
    const reseller_cameras = ref(null);
    const loadingToast = ref(null);
    const toast = useToast();

    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value
        ? refListTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalList.value,
      };
    });

    const itemsData = computed(() => {
      return resellerCameras.value.slice(
        (currentPage.value - 1) * perPage.value,
        currentPage.value * perPage.value
      );
    });

    watch(filterReseller, () => {
      getResellerCameras();
    });

    watch(selectAll, () => {
      if (selectAll.value == 1) {
        cameras.value = resellerCameras.value.filter((camera) => !camera.exist);
        camerasModel.value = resellerCameras.value.map(camera => camera.cameraId);
      } else {
        cameras.value = [];
        camerasModel.value = resellerCameras.value.map(camera => camera.exist ? camera.cameraId : null )
      }
    });

    watch(cameras, () => {
      if(cameras.value.length === 0){
        selectAll.value = 0;
      }
    });

    const onShow = () => {
      filterReseller.value = props.resellerFilter;
      clear();
    };

    const clear = () => {
      selectAll.value = 0;
      cameras.value = [];
    };

    const checkItem = (camera) => {
      const res  = resellerCamerasTemp.value.find(r => r.cameraId == camera.cameraId);
      if(cameras.value.find(item => item.cameraId === camera.cameraId)){
        let cam =  cameras.value.filter(item => item.cameraId !== camera.cameraId);
        cameras.value = cam;
      }
      else{
        cameras.value.push(res)
      }
    }

    const getResellerCameras = () => {
      clear();
      if (filterReseller.value.length < 1) return;

      isBusy.value = true;
      totalList.value = 0;

      store
        .dispatch("cm_camera/getResellerCameras", {
          id_resellers: filterReseller.value,
        })
        .then((response) => {
          if (response.success) {
            resellerCameras.value = response.data.cameras;
            resellerCamerasTemp.value = resellerCameras.value;
            camerasModel.value = resellerCameras.value.map(camera => camera.exist ? camera.cameraId : null )
            totalList.value = response.data.cameras.length;
            isBusy.value = false;
          }
        })
        .catch((response) => {
          toast({
            component: ToastificationContent,
            props: {
              title: response.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    const onTypeSearch = debounce(function (event) {
      clear();
      if (event === "") {
        resellerCameras.value = resellerCamerasTemp.value;
        camerasModel.value = resellerCamerasTemp.value.map(camera => camera.exist ? camera.cameraId : null )
        totalList.value = resellerCameras.value.length;
        return;
      }

      const search = event.toLowerCase();
      resellerCameras.value = resellerCamerasTemp.value.filter(
        (item) =>
          item.name.toLowerCase().includes(search) ||
          item.ethMacAddress.toLowerCase().includes(search)
      );

      currentPage.value = 1;
      totalList.value = resellerCameras.value.length;
    }, 800);

    const updateResellerCameras = () => {
      if (cameras.value.length === 0) {
        return toast({
          component: ToastificationContent,
          props: {
            title: parent.$i18n.t("camera.cameras_validation"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      emit("loading-toast-event", { data: true });
      buttonUpdate.value = true;

      store
        .dispatch("cm_camera/updateResellerCameras", {
          cameras: cameras.value,
        })
        .then((response) => {
          if (response.success) {
            window.Echo.private(
              `cameras-updating-${response.data.jobId}`
            ).listen(".update", (data) => {
              if (
                data.message.totalCameras == 1 &&
                data.message.event == "finish"
              ) {
                clear();
                reseller_cameras.value.hide();
                emit("loading-toast-event", { data: false });
                buttonUpdate.value = false;
              }
            });
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: "Error al actualizar cámaras",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Error al actualizar cámaras",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    return {
      isBusy,
      perPage,
      totalList,
      currentPage,
      perPageOptions,
      refListTable,
      tableColumns: [
        { label: "", key: "cameraId", sortable: false },
        { label: "camera.name", key: "name", sortable: true },
        { label: "camera.mac_address", key: "ethMacAddress", sortable: true },
      ],
      buttonUpdate,
      filterReseller,
      selectAll,
      camerasModel,
      cameras,
      itemsData,
      dataMeta,
      loadingToast,
      reseller_cameras,

      clear,
      onShow,
      onTypeSearch,
      getResellerCameras,
      updateResellerCameras,
      checkItem,
    };
  },
};
</script>